/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Container, Col, Button, FormGroup, Label, Input, Row, Spinner } from 'reactstrap'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import Files from 'react-files'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { notifyError } from '../../../utils/notify'
import { registerAbsence } from '../../../store/ducks/humanResources'

class RegisterAbsence extends Component {
  constructor(props) {
    super(props)
    this.state = {
      justificationInitialDate: '',
      justificationInitialDateInputError: '',
      justificationEndDateInputError: '',
      justificationEndDate: '',
      justificationInitialHour: '',
      justificationInitialHourInputError: '',
      justificationEndHour: '',
      justificationEndHourInputError: '',
      justificationObservations: '',
      justificationObservationsInputError: '',
      justificationFiles: [],
      justificationFilesInputError: '',
    }
    this.files = React.createRef()
  }

  strToMins = (t) => {
    const s = t.split(':')
    return Number(s[0]) * 60 + Number(s[1])
  }

  handleJustificationSubmit = () => {
    const {
      justificationInitialDate, justificationEndDate, justificationObservations, justificationFiles,
      justificationInitialHour, justificationEndHour, justificationInitialHourInputError, justificationEndHourInputError,
    } = this.state
    const { registerAbsence } = this.props

    if (!justificationInitialDate) this.setState({ justificationInitialDateInputError: 'Campo obrigatório.' })
    if (!justificationEndDate) this.setState({ justificationEndDateInputError: 'Campo obrigatório.' })
    /* if (!justificationType) this.setState({ justificationTypeInputError: 'Campo obrigatório.' }) */
    if (!justificationObservations) this.setState({ justificationObservationsInputError: 'Campo obrigatório.' })
    if (!justificationFiles || justificationFiles.length < 1) this.setState({ justificationFilesInputError: 'Adicione ao menos um documento anexo.' })
    if (
      justificationInitialDate
      && justificationEndDate
      && (moment(justificationInitialDate).format('YYYY-MM-DD') === moment(justificationEndDate).format('YYYY-MM-DD'))
      && !justificationInitialHour
    ) this.setState({ justificationInitialHourInputError: 'Campo obrigatório.' })
    if (
      justificationInitialDate
      && justificationEndDate
      && (moment(justificationInitialDate).format('YYYY-MM-DD') === moment(justificationEndDate).format('YYYY-MM-DD'))
      && !justificationEndHour
    ) this.setState({ justificationEndHourInputError: 'Campo obrigatório.' })
    if (
      justificationInitialDate
      && justificationEndDate
      && (moment(justificationInitialDate).format('YYYY-MM-DD') === moment(justificationEndDate).format('YYYY-MM-DD'))
      && justificationInitialHour
      && !HOUR_MINUTE_REGEX.test(justificationInitialHour)
    ) {
      this.setState({ justificationInitialHourInputError: 'Valor inválido.' })
    }
    if (
      justificationInitialDate
      && justificationEndDate
      && (moment(justificationInitialDate).format('YYYY-MM-DD') === moment(justificationEndDate).format('YYYY-MM-DD'))
      && justificationInitialHour
      && (
        !HOUR_MINUTE_REGEX.test(justificationEndHour)
        || (this.strToMins(justificationEndHour) - this.strToMins(justificationInitialHour) <= 0)
      )
    ) {
      this.setState({ justificationEndHourInputError: 'Valor inválido.' })
    }
    if (moment(justificationEndDate).isBefore(justificationInitialDate)) this.setState({ justificationEndDateInputError: 'Data final anterior à inicial.' })

    if (
      justificationInitialDate && justificationEndDate && justificationObservations
      && justificationFiles && justificationFiles.length > 0
    ) {
      if (
        moment(justificationInitialDate).format('YYYY-MM-DD') !== moment(justificationEndDate).format('YYYY-MM-DD')
        && moment(justificationEndDate).isAfter(justificationInitialDate)
      ) {
        registerAbsence({
          DataEntrada: moment(justificationInitialDate).format('YYYY-MM-DD'),
          DataSaida: moment(justificationEndDate).format('YYYY-MM-DD'),
          /* Motivo: justificationType, */
          Justificativa: justificationObservations,
          files: justificationFiles,
        })
      } else if (
        justificationInitialHour && justificationEndHour && !justificationInitialHourInputError && !justificationEndHourInputError
        && HOUR_MINUTE_REGEX.test(justificationInitialHour) && HOUR_MINUTE_REGEX.test(justificationEndHour)
        && this.strToMins(justificationEndHour) - this.strToMins(justificationInitialHour) > 0
      ) {
        registerAbsence({
          DataEntrada: moment(justificationInitialDate).format('YYYY-MM-DD'),
          DataSaida: moment(justificationEndDate).format('YYYY-MM-DD'),
          HoraEntrada: justificationInitialHour,
          HoraSaida: justificationEndHour,
          /* Motivo: justificationType, */
          Justificativa: justificationObservations,
          files: justificationFiles,
        })
      }
    }
  }

  render() {
    const { registerAbsenceIsLoading } = this.props.humanResources
    const {
      justificationInitialDate, justificationObservations, justificationEndDate,
      justificationInitialDateInputError, justificationEndDateInputError,
      justificationObservationsInputError, justificationFiles, justificationFilesInputError,
      justificationInitialHour, justificationInitialHourInputError,
      justificationEndHour, justificationEndHourInputError,
    } = this.state

    return (
      <div className="page-content">
        <Container fluid style={{ minHeight: 500 }}>
          <Breadcrumbs
            title="Justificativa de ausência"
            breadcrumbItems={[{
              title: '',
            }]}
          />
          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Data inicial</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={justificationInitialDate}
                  dateFormat="dd/MM/yyyy"
                  filterDate={date => {
                    const day = moment(date).day()
                    return day !== 0 && day !== 6
                  }}
                  onChange={justificationInitialDate => this.setState({
                    justificationInitialDate,
                    justificationInitialDateInputError: '',
                  })}
                />
                {
                  justificationInitialDateInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {justificationInitialDateInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Data final</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={justificationEndDate}
                  dateFormat="dd/MM/yyyy"
                  filterDate={date => {
                    const day = moment(date).day()
                    return day !== 0 && day !== 6
                  }}
                  onChange={justificationEndDate => this.setState({
                    justificationEndDate,
                    justificationEndDateInputError: '',
                  })}
                />
                {
                  justificationEndDateInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {justificationEndDateInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          {
            justificationInitialDate && justificationEndDate
            && moment(justificationInitialDate).format('YYYY-MM-DD') === moment(justificationEndDate).format('YYYY-MM-DD')
            && (
              <>
                <Row>
                  <Col xl={3} lg={4} md={4} sm={4}>
                    <FormGroup>
                      <Label>Hora inicial</Label>
                      <Input
                        className="form-control"
                        type="text"
                        value={justificationInitialHour}
                        maxLength={5}
                        onChange={e => this.setState({
                          justificationInitialHour: e.target.value,
                          justificationInitialHourInputError: '',
                        })}
                      />
                      {
                        justificationInitialHourInputError
                        && (
                          <span style={{ color: 'red' }}>
                            {justificationInitialHourInputError}
                          </span>
                        )
                      }
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col xl={3} lg={4} md={4} sm={4}>
                    <FormGroup>
                      <Label>Hora final</Label>
                      <Input
                        className="form-control"
                        type="text"
                        value={justificationEndHour}
                        maxLength={5}
                        onChange={e => this.setState({
                          justificationEndHour: e.target.value,
                          justificationEndHourInputError: '',
                        })}
                      />
                      {
                        justificationEndHourInputError
                        && (
                          <span style={{ color: 'red' }}>
                            {justificationEndHourInputError}
                          </span>
                        )
                      }
                    </FormGroup>
                  </Col>
                </Row>
              </>
            )
          }

          {/* <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Motivo</Label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  placeholder="Selecione o motivo..."
                  options={[
                    {
                      value: 'Doença',
                      label: 'Doença',
                    },
                    {
                      value: 'Consulta médica',
                      label: 'Consulta médica',
                    },
                    {
                      value: 'Problema particular',
                      label: 'Problema particular',
                    },
                    {
                      value: 'Outro',
                      label: 'Outro',
                    },
                  ]}
                  onChange={({ value }) => this.setState({ justificationType: value, justificationTypeInputError: '' })}
                />
                {
                  justificationTypeInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {justificationTypeInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row> */}

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={justificationObservations}
                  onChange={e => this.setState({
                    justificationObservations: e.target.value,
                    justificationObservationsInputError: '',
                  })}
                />
                {
                  justificationObservationsInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {justificationObservationsInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <Label>Anexos</Label>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                outline
                color="primary"
                type="button"
                className="mb-3 mt-1"
                size="sm"
              >
                <Files
                  multiple
                  clickable
                  ref={this.files}
                  onChange={files => {
                    this.setState({ justificationFiles: files, justificationFilesInputError: '' })
                  }}
                  onError={(error) => notifyError(error.message)}
                  accepts={['image/png', 'image/jpg', 'image/jpeg', '.pdf']}
                  maxFiles={3}
                  maxFileSize={10000000}
                  minFileSize={1}
                >
                  <i className="ri-attachment-2 align-middle mr-2" />
                  <span className="align-middle">Adicionar arquivos</span>
                </Files>
              </Button>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              {justificationFiles && justificationFiles.length > 0 && (
                <div className="files-list">
                  <ul>
                    {justificationFiles.map((file) => (
                      <li className="files-list-item" key={file.id}>
                        <div className="files-list-item-preview">
                          {file.preview.type === 'image'
                            ? <img className="files-list-item-preview-image" alt="Prévia de arquivo" src={file.preview.url} />
                            : <div className="files-list-item-preview-extension">{file.extension}</div>}
                        </div>
                        <div className="files-list-item-content">
                          <div className="files-list-item-content-item files-list-item-content-item-1">{file.name}</div>
                          <div className="files-list-item-content-item files-list-item-content-item-2">{file.sizeReadable}</div>
                        </div>
                        <div
                          id={file.id}
                          className="files-list-item-remove"
                          onClick={() => this.files.current.removeFile(file)}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {
                justificationFilesInputError
                && (
                  <span style={{ color: 'red' }}>
                    {justificationFilesInputError}
                  </span>
                )
              }
            </Col>
          </Row>

          <Button
            type="button"
            color="primary"
            className="mt-3 waves-effect waves-light"
            disabled={registerAbsenceIsLoading}
            onClick={() => this.handleJustificationSubmit()}
          >
            Enviar
            {registerAbsenceIsLoading && (
              <Spinner size="sm" className="ml-2" />
            )}
          </Button>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ registerAbsence }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(RegisterAbsence)

const HOUR_MINUTE_REGEX = new RegExp('^([01]?[0-9]|2[0-3]):[0-5][0-9]$')
